import { ProtectedRoute } from '@/components/auth/ProtectedRoute';
import { EditClientForm } from '@/components/clients/EditClientForm';

export default function EditClientPage() {
  return (
    <ProtectedRoute>
      <EditClientForm />
    </ProtectedRoute>
  );
}
